var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormContributorsItem.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormContributorsItem.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormContributors.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormContributors.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormContributorsItem.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormContributors.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "SubmissionFormContributorsItem")) {
var t_7 = t_4.SubmissionFormContributorsItem;
} else {
cb(new Error("cannot import 'SubmissionFormContributorsItem'")); return;
}
context.setVariable("SubmissionFormContributorsItem", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"SubmissionFormContributors\">\n\n        <div class=\"SubmissionFormElement-form SubmissionFormElement-form--border\">\n            <h3 class=\"SubmissionFormElement-header\">Submission Contributors</h3>\n\n            <div class=\"SubmissionFormContributors-description\">If you would like to allow someone else to edit or contribute to this submission, simply enter their e-mail address. When you save or submit this project, they will receive an invite to register on <a href=\"https://awards.adg.org\">awards.adg.org</a>. Once they have created an account, they will be able to edit or complete the submission.</div>\n\n            <div class=\"SubmissionFormContributors-wrapper\">\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"contributors") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"contributors"))) {
t_9 += "\n                    ";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"contributors");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_9 += "\n                        ";
t_9 += runtime.suppressValue((lineno = 15, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormContributorsItem"), "SubmissionFormContributorsItem", context, [runtime.makeKeywordArgs({"data": t_13})])), env.opts.autoescape);
t_9 += "\n                    ";
;
}
}
frame = frame.pop();
t_9 += "\n                ";
;
}
else {
t_9 += "\n                    ";
t_9 += runtime.suppressValue((lineno = 18, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormContributorsItem"), "SubmissionFormContributorsItem", context, [])), env.opts.autoescape);
t_9 += "\n                ";
;
}
t_9 += "\n            </div>\n\n            <div class=\"SubmissionFormContributors-footer ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"contributors") && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"contributors")) >= 1) {
t_9 += " SubmissionFormContributors-footer--hidden";
;
}
t_9 += "\">\n                <div class=\"SubmissionFormContributors-add\"><span>+</span><span>Add another e-mail</span></div>\n            </div>\n        </div>\n\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("SubmissionFormContributors");
context.setVariable("SubmissionFormContributors", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormContributors.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormContributors.jinja
// module id = 53
// module chunks = 0